var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_549_3487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.52202 13.5004L3.53035 11.1782C2.75892 10.0831 2.41365 8.74417 2.55932 7.4126C2.705 6.08104 3.33161 4.8484 4.32156 3.94602C5.31151 3.04365 6.59675 2.53356 7.93608 2.51149C9.27541 2.48942 10.5768 2.95688 11.5959 3.82616C12.6151 4.69543 13.2819 5.90675 13.4714 7.23279C13.6609 8.55884 13.3599 9.90845 12.625 11.0283C11.89 12.1482 10.7717 12.9614 9.47976 13.3153C8.18784 13.6692 6.81118 13.5395 5.60813 12.9504L2.52202 13.5004",
    stroke: "#222222",
    strokeWidth: 1.39329,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.18868 6.77799C6.18868 6.85903 6.22087 6.93675 6.27818 6.99406C6.33548 7.05136 6.4132 7.08355 6.49424 7.08355C6.57528 7.08355 6.653 7.05136 6.7103 6.99406C6.7676 6.93675 6.79979 6.85903 6.79979 6.77799V6.16688C6.79979 6.08585 6.7676 6.00813 6.7103 5.95082C6.653 5.89352 6.57528 5.86133 6.49424 5.86133C6.4132 5.86133 6.33548 5.89352 6.27818 5.95082C6.22087 6.00813 6.18868 6.08585 6.18868 6.16688V6.77799ZM6.18868 6.77799C6.18868 7.58838 6.51061 8.36557 7.08363 8.9386C7.65666 9.51163 8.43385 9.83355 9.24424 9.83355H9.85535C9.93639 9.83355 10.0141 9.80136 10.0714 9.74406C10.1287 9.68675 10.1609 9.60903 10.1609 9.52799C10.1609 9.44696 10.1287 9.36924 10.0714 9.31193C10.0141 9.25463 9.93639 9.22244 9.85535 9.22244H9.24424C9.1632 9.22244 9.08548 9.25463 9.02818 9.31193C8.97088 9.36924 8.93868 9.44696 8.93868 9.52799C8.93868 9.60903 8.97088 9.68675 9.02818 9.74406C9.08548 9.80136 9.1632 9.83355 9.24424 9.83355",
    stroke: "#222222",
    strokeWidth: 1.39329,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_549_3487"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.6667,
    height: 14.6667,
    fill: "white",
    transform: "translate(0.68869 0.666992)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.689e8841373ebc802db6929a586804e3.svg";
export { ForwardRef as ReactComponent };